<template>
	<div class="mask">
		<Container v-show='!showPayCode'>
			<TopBar />
			<div class='paymentPage' v-if='desc'>
				<h2 class="mergeFree">合并支付:¥{{desc.TotalPaid.toFixed(2)}}</h2>
				<div class="mid" >

					<div class="payList">
						<div class="item" @click="swtichPayChannel(20)">
							<div class="left">
								<img src="@/assets/order/wechat.png">
								<b>微信</b>
							</div>
							<img v-if='payChannel==20' class="right" src="@/assets/order/hook.png">
						</div>
						<div class="item align" @click="swtichPayChannel(1)">
							<div class="left">
								<img src="@/assets/order/alipay.png">
								<b>支付宝</b>

							</div>
							<img v-if='payChannel==1' class="right" src="@/assets/order/hook.png">
						</div>
						<div class="item" @click="swtichPayChannel(4)">
							<div class="left">
								<img src="@/assets/order/manyPay1.png">
								<b>支持支付宝、云闪付扫码支付</b>
							</div>
							<img v-if='payChannel==4' class="right" src="@/assets/order/hook.png">
						</div>
						
						<div class="item" @click="swtichPayChannel(3)">
							<div class="left">
								<img src="@/assets/order/unionpay.png">
								<b>单笔订单超20000元建议使用银联支付</b>

							</div>
							<img v-if='payChannel==3' class="right" src="@/assets/order/hook.png">
						</div>

					</div>
				</div>
				<div class="foot">
					<Button size='large' :loading="!IsPay" :disabled='payChannel == 0' type="primary" shape="circle" @click="goPay">去支付</Button>
				</div>
			</div>

		</Container>
		<transition name="fade">
			<div v-show='showPayCode' class="qrcode-bg">
				<div class='desc' v-if='desc'>
					<p>请您及时付款，以便订单尽快处理！订单号：{{$route.query.os}}</p>
					<p>Please pay timely! Order number: {{$route.query.os}}</p>
					<br>

					<p>请您在提交订单后尽快完成支付, 否则订单将{{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}后取消。</p>
					<p>Please pay timely, time for payment left: {{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}</p>
					<br>
					<p>应付金额:<b>{{desc.TotalPaid.toFixed(2)}}</b>元</p>

					<p>Total:<b>{{desc.TotalPaid.toFixed(2)}}</b>Yuan</p>
					<div class="qrcode" id='payQRCode'>
						<img :src='QRImg'>
						<div class="qrcode-desc">

							<template v-if='payChannel==2||payChannel==20'>
								<p>请使用微信扫一扫<b>(Use Wechat to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==4'>
								<p>请使用支付软件扫一扫<b>(Use software to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==1'>
								<p>请使用支付宝扫一扫<b>(Use AliPay to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
						</div>
					</div>
					<div class='p-w-sidebar' :class="{alipay:payChannel==1,jhzf:payChannel==4}">

					</div>
				</div>
				<div class="close">
					<svg width="60" height="60" style='cursor: pointer;' @click='colse'>
						<circle cx="30" cy="30" r="25" stroke="#636363" stroke-width="2" fill="none" />
						<line x1="22" y1="38" x2="38" y2="22" style="stroke:#636363;stroke-width:2" />
						<line x1="22" y1="22" x2="38" y2="38" style="stroke:#636363;stroke-width:2" />
					</svg>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { api_methods } from "@/service/loadData";
import { QRCode } from "@/assets/js/qrcode.js";
import { baseUrl, cdoUrl } from "@/config/env";
export default {
	data() {
		return {
			payChannel: 20, // 1:支付宝 2、20:微信 3:银联支付
			auto: false,
			result: false,
			IsPay: true,
			countNum: 0,

			desc: null,
			list: null,
			selectdesc: null,
			showPayCode: false,
			order_no: null,
			ajaxpay: null,
			forTime: [5000, 3000],
			forIndex: 0,
			QRImg: null,
			PayIn: false,

			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				zip: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1",
			},
			show: false,
			addressLoading: false,
			doAccount:null,
			caddress: {},
		};
	},
	created() {
		this.$nextTick(function () {
			this.initData(this.$route.query.no);
		});
	},
	beforeDestroy: function () {
		clearInterval(this.timer);
		clearInterval(this.ajaxpay);
	},
	mounted() {},
	watch: {},
	mixins: [],
	components: {
		TopBar,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo"]),
		...mapState({
			userInfo: (state) => state.common.wechatUserInfo.value,
		}),
		remaining: function () {
			let hour = parseInt(this.countNum / 3600);
			if (hour < 10) {
				hour = "0" + hour;
			}
			let minute = parseInt((this.countNum % 3600) / 60);
			if (minute < 10) {
				minute = "0" + minute;
			}
			let second = parseInt(this.countNum % 60);
			if (second < 10) {
				second = "0" + second;
			}
			return { hour, minute, second };
			//return hour + " : " + minute + " : " + second;
		},
		passwordTel: function () {
			if (
				this.selectdesc.moblie_phone &&
				this.selectdesc.moblie_phone.length >= 11
			) {
				return this.selectdesc.moblie_phone.replace(
					/(\d{3})\d{4}(\d{4})/,
					"$1****$2"
				);
			} else {
				return this.selectdesc.moblie_phone;
			}
		},
		productText: function () {
			if (this.list && this.list.length > 0) {
				return (
					"【doTERRA】" +
					this.list[0].name +
					(this.list[0].specification || "")
				);
			}
			return "暂无信息";
		},
		productCount: function () {
			if (this.list && this.list.length > 0) {
				return this.list.length;
			}
			return 0;
		},
		hideNewCustomerCell(){
			return this.userInfo.binding.first_order_status == 0
		},
	},

	methods: {
		...mapActions([
			"unionPayAction",
			"getOrderStatusAction",
			"getWechatUserInfoAction",
			'getMergePayOrderAction',
		]),
		...mapMutations([
			"SAVE_PAYRECORD",
			"SET_ORDERSTATUS",
			"SAVE_USER_TIME",
		]),
		async initData(os) {
			let response = await this.getMergePayOrderAction(os)
			this.desc = response.OrderInfo[0]
			if (this.desc.Code != 1) {
				this.$Modal.info({
					title: "提示 (info)",
					content: this.desc.Message,
					onOk:()=>{
						this.$router.replace('/order/orders')
					}
				})
			}
		},
		swtichPayChannel(channel){
			if (channel == 5 && this.doAccount.val < this.desc.TotalPaid) return
			this.payChannel = channel
		},
		confirm() {
			this.$router.push("/order/mergepayresult");
		},
		async goPay() {
			if (this.payChannel == 3) {
				location = `${cdoUrl}/Public/Pay/SF/Pay.aspx?order_no=${this.$route.query.no}&pc_no=${this.getVipNo}`;
			} else if (this.payChannel == 1) {
				location = `${cdoUrl}/Public/Pay/AliPay/AliPagePay.aspx?orderno=${this.$route.query.no}&pc_no=${this.getVipNo}`;
			} else if (this.payChannel == 5) {
				location = `${cdoUrl}/Public/Pay/SF/BalancePay.aspx?orderno=${this.$route.query.no}&pc_no=${this.getVipNo}&channel=WebSite`;
			} else {
				var app = "sftogether";
				if (this.payChannel == 2) {
					app = "sfwechat";
				} else if (this.payChannel == 1) {
					app = "sfalipay";
				} else if (this.payChannel == 20) {
					app = "wechat";
				} else if (this.payChannel ==  5) {
					app = "DH";
				}
				//if(this.payChannel)
				let response = await this.unionPayAction({
					order_no: this.$route.query.no,
					orderno_tip: this.$route.query.no,
					pc_no: this.getVipNo,
					app,
				});
				if (response && response.Status == 1 && response.QRCode) {
					let el = document.createElement("div");
					var qrcode = new QRCode(el, {
						text: response.QRCode,
						width: 300,
						height: 300,
						colorDark: "#000000",
						colorLight: "#ffffff",
						correctLevel: QRCode.CorrectLevel.H,
					});

					let desEl = document.getElementById("payQRCode");

					desEl.replaceChild(
						qrcode._el.children[1],
						desEl.firstChild
					);
					desEl.firstChild.style.width = "90%";
					desEl.firstChild.style.margin = "0 auto";

					this.showPayCode = true;
					this.PayIn = true;
					this.beginfor(this.$route.query.no);
				} else if (response && !response.QRCode) {
					var params = {
						charset: response.charset,
						signType: response.signType,
						//"data":this.HTMLDecode(response.data),
						data: response.data,
						sign: response.sign,
						extend: response.extend,
					};
					this.standardPost(response.serverUrl, params);
				} else if (response) {
					this.$Modal.error({
						title: "支付失败",
						content: response.Message,
					});
				} else {
					this.$Modal.error({
						title: "支付失败",
						content: "支付发生异常,请重新尝试",
					});
				}
			}
		},
		colse() {
			this.showPayCode = false;
			clearInterval(this.ajaxpay);
		},
		beginfor(orderNo) {
			var vm = this;
			var s =
				this.forTime[this.forIndex] ||
				this.forTime[this.forTime.length - 1];
			clearInterval(this.ajaxpay);
			this.ajaxpay = setInterval(function () {
				vm.forOrderStatus(orderNo);
			}, s); // 每间隔一秒执行一次
		},
		async forOrderStatus(orderNo) {
			let res = await this.getOrderStatusAction(orderNo);
			console.log("查询支付结果");
			if (res) {
				if (res.OrderStatuss == "Pay" || res.OrderStatuss == "Confirm") {
					clearInterval(this.ajaxpay);
					this.SAVE_USER_TIME();
					//this.SET_ORDERSTATUS(res);
					this.$router.push({
						path: "/order/mergepayresult",
						query: {
							type: "yes",
							orderno: this.$route.query.no,
							os: this.$route.query.os,
						},
					});
					return
				}
			}
			this.forIndex++;
			this.beginfor(orderNo);
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.paymentPage {
	width: 70.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.top {
	text-align: center;
	margin: auto;
	margin-top: 30px;
	.logo {
		margin: auto;
		width: 150px;
		border-radius: 200px;
		box-shadow: 1px 1px 20px #dddddd8c;
		height: 150px;
		text-align: center;
		line-height: 210px;
		img {
			width: 55px;
		}
	}
	h2 {
		color: $green;
		margin-top: 20px;
	}
	.time {
		margin-top: 20px;
		span {
			padding: 5px;
			background-color: $theme-color;
			display: inline-block;
			color: white;
		}
		i {
			font-style: normal;
			@include fontSize($font-size-13);
			margin: 0 5px;
		}
		b {
			font-weight: 500;
			margin-right: 5px;
		}
	}
	p {
		margin-top: 20px;
	}
}
.mid {
	width: 40.03vw;
	margin: auto;
	margin-top: 20px;
	.orderNo {
		border-bottom: 1px solid #dedede;
		height: 30px;
		b {
			float: left;
		}
		span {
			float: right;
			padding: 1px 10px;
			border: 1px solid $theme-color;
			color: $theme-color;
			@include fontSize($font-size-13);
			border-radius: 10px;
		}
	}
	.info {
		border-bottom: 1px solid #dedede;
		.item {
			height: 30px;
			line-height: 30px;
			overflow: hidden;
			span:nth-of-type(2) {
				color: $theme-color;
				float: right;
			}
		}
		&.address {
			span:nth-of-type(2) {
				color: #636363;
				float: right;
			}
			b.update {
				color: $theme-color;
				font-weight: 800;
				cursor: pointer;
			}
		}
	}
	.total {
		margin-top: 10px;
		font-weight: 500;
		margin-bottom: 10px;
	}
	.payList {
		.item {
			cursor: pointer;
			padding: 10px 0;
			//clear: both;
			overflow: hidden;
			border-bottom: 1px solid #dedede;

			.left {
				float: left;
				img {
					width: 50px;
				}
				b {
					padding-left: 10px;
					position: relative;
					top: -15px;
				}
			}
			.right {
				float: right;
				width: 25px;
				margin-top: 10px;
			}
		}
	}
}
.foot {
	margin-top: 20px;
	text-align: center;
	button {
		padding: 0 35px;
	}
}

.qrcode-bg {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: white;
	overflow: scroll;
	z-index: 2000;
	//   overflow: hidden;
	.desc {
		display: block;
		position: absolute;
		top: 30px;
		left: 5%;
		width: 95%;
		overflow: hidden;
		//left: calc(45vw - 150px);
		& > p {
			@include fontSize($font-size-18);
			font-weight: bold;
			color: #636363;
			text-rendering: optimizeSpeed;
			font-style: normal;
			b {
				@include fontSize($font-size-30);
				vertical-align: middle;
				color: #bc86c8;
				margin: 0 10px;
				position: relative;
				top: -5px;
			}
		}
	}
	.qrcode {
		margin-top: 20px;
		display: block;
		// position: absolute;
		width: 300px;
		// height: 300px;
		float: left;
		// top: calc(40vh - 50px);
		// left: calc(50vw - 400px);
		.qrcode-desc {
			width: 100%;
			// height: 58px;
			background-color: #bc86c8;
			line-height: 22px;
			color: white;
			text-align: center;
			font-weight: 700;
			@include fontSize($font-size-15);
			line-height: 27px;
			margin-top: 20px;
			b {
				@include fontSize($font-size-13);
				font-weight: 500;
				// display: block;
			}
		}
	}
	.qrimg {
		width: 90%;
		margin: auto;
	}
	.close {
		position: fixed;
		top: calc(3vh - 0px);
		//left: calc(50vw - 30px);
		right: 30px;
	}
}
.p-w-sidebar {
	float: left;
	width: 379px;
	height: 421px;
	padding-left: 50px;
	// margin-top: -20px;
	background: url(http://cdn.doterra.cn/skin/frontend/rwd/dtr/images/phone-bg.png)
		50px 0 no-repeat;
	&.alipay {
		background: url(../../../assets/order/phone-alipay-bg.png) 50px 0
			no-repeat;
	}
	&.jhzf {
		background: url(../../../assets/order/phone-jhzf-bg.png) 50px 0
			no-repeat;
	}
}
.mergeFree {
	text-align: center;
	@include fontSize($font-size-16);
	color: $theme-color;
}

@media (max-width: 768px){
	.paymentPage{
		width: 90%;
		font-size: 0.5rem;

	}
	.mid{
		width: 100%;
	}
	.qrcode-bg .desc > p{
		b{
			font-size: 0.7rem;
		}
		font-size: 0.5rem;
	}
	.qrcode-bg .close{
		right: 0;
	}
	.qrcode-bg .qrcode .qrcode-desc{
		font-size: 0.55rem;
		b{
			font-size: 0.5rem;
		}
	}
	
}
.invalid {
	filter:grayscale(0.9);
	color:#999;
}

</style>